import React from "react";
import { number } from "prop-types";

const QuintLensIcon = ({ width = 106, height = 70 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 106.167 42">
    <g transform="translate(-429 -7836)">
      <g transform="translate(429 7836)">
        <path
          d="M29.5 41.984L26.788 39.1c-3.573-3.843-7.242-7.675-10.827-11.553a2.064 2.064 0 0 0-1.667-.715c-2.18 0-4.371-.07-6.551-.2a8.761 8.761 0 0 1-4.323-1.3A7.246 7.246 0 0 1 .3 20.647a14.8 14.8 0 0 1-.3-3.586V13.78c0-1.922.071-3.832.143-5.753a15.831 15.831 0 0 1 .526-4.019A5.188 5.188 0 0 1 5.04.176 15.215 15.215 0 0 1 8.887.071q2.668.2 5.312.562a62.866 62.866 0 0 1 6.217 1.055 7.189 7.189 0 0 1 5.312 4.687 29.043 29.043 0 0 1 1.191 4.687c.572 2.742 1.084 5.484 1.584 8.2a9.1 9.1 0 0 1 0 3.609 4.224 4.224 0 0 1-3.121 3.257l-.488.129c-.417.094-.417.094-.3.469l4.848 15.08V42z"
          transform="translate(.009 .004)"
          fill="#febf0f"
        />
        <g transform="translate(6.468 7.561)">
          <ellipse cx="2.298" cy="2.259" rx="2.298" ry="2.259" transform="translate(4.883 4.8)" />
          <path
            d="M9.027 4L7.712 5.412H5.436A1.424 1.424 0 0 0 4 6.824v8.471a1.424 1.424 0 0 0 1.436 1.412h11.489a1.424 1.424 0 0 0 1.436-1.412V6.824a1.424 1.424 0 0 0-1.436-1.412h-2.276L13.335 4zm2.154 10.588a3.53 3.53 0 1 1 3.59-3.529 3.562 3.562 0 0 1-3.59 3.529z"
            transform="translate(-4 -4)"
          />
        </g>
      </g>
    </g>
  </svg>
);

QuintLensIcon.propTypes = {
  width: number,
  height: number,
};

export default QuintLensIcon;
